<template>
  <div>
    <helpers-section-header class="mt-6 mb-8"> 13F Indicator Signal Rules </helpers-section-header>
    <p>
      Create rules filtering stock selections based on 13F indicators. First create a rule group.
      Then add indicatorss to your rule group.
    </p>
    <v-row density="compact">
      <v-col cols="12">
        <v-data-table
          :headers="group_headers"
          :items="criteria.rules"
          hide-default-footer
          items-per-page="-1"
          class="mt-6 mb-8"
        >
          <template #top>
            <v-dialog v-model="groupDialog" fullscreen>
              <template #activator="{ props }">
                <v-btn color="primary" style="max-width: 350px" class="mb-4" v-bind="props">
                  Create New Rule Group
                </v-btn>
              </template>
              <v-card>
                <v-card-title>
                  <span class="text-h5">{{ groupTitle }}</span>
                </v-card-title>

                <v-card-text>
                  <v-row density="compact">
                    <v-col cols="12" sm="12">
                      <v-checkbox
                        v-model="editedGroup.enabled"
                        density="compact"
                        label="Rule Enabled"
                      />
                    </v-col>
                    <v-col cols="12" sm="12" md="6">
                      <v-select
                        v-model="editedGroup.and_or"
                        :items="[
                          { id: 1, description: 'All rules must match for a stock to be chosen' },
                          {
                            id: 2,
                            description: 'If any rule matches then the stock will be chosen'
                          }
                        ]"
                        item-title="description"
                        item-value="id"
                        label="How are stocks matched?"
                        density="compact"
                        hide-details
                        variant="outlined"
                      />
                    </v-col>
                    <v-col cols="12">
                      <v-data-table
                        :headers="metric_headers"
                        :items="editedGroup.metric_rules"
                        hide-default-footer
                        items-per-page="-1"
                      >
                        <template #top>
                          <v-dialog v-model="metricDialog" persistent scrollable max-width="650px">
                            <template #activator="{ props }">
                              <v-btn
                                color="primary"
                                style="max-width: 350px"
                                class="mb-4"
                                v-bind="props"
                              >
                                Add 13F Indicator To Group
                              </v-btn>
                            </template>
                            <v-card>
                              <v-card-title>
                                <span class="text-h5">{{ metricTitle }}</span>
                              </v-card-title>

                              <v-card-text style="height: 350px">
                                <p />
                                <v-container>
                                  <v-row density="compact">
                                    <v-col cols="12" sm="12">
                                      <v-checkbox
                                        v-model="editedMetric.enabled"
                                        density="compact"
                                        label="Rule Enabled"
                                      />
                                    </v-col>
                                    <v-col cols="12" sm="12">
                                      <v-autocomplete
                                        v-model="editedMetric.metric"
                                        :items="metrics"
                                        label="13F Indicator"
                                        item-title="name"
                                        item-value="id"
                                        variant="outlined"
                                        density="compact"
                                        hide-details
                                      />
                                    </v-col>
                                    <v-col
                                      v-if="
                                        editedMetric.metric &&
                                        (editedMetric.metric == 'rising_stars' ||
                                          editedMetric.metric == 'falling_stars')
                                      "
                                      cols="12"
                                      sm="12"
                                    >
                                      <v-text-field
                                        v-model="editedMetric.min"
                                        style="max-width: 200px"
                                        density="compact"
                                        variant="outlined"
                                        persistent-hint
                                        label=""
                                        :hint="'Min # of Hedge Funds Holding Stock in Previous Quarter '"
                                      />
                                      <v-text-field
                                        v-model="editedMetric.min2"
                                        style="max-width: 200px"
                                        density="compact"
                                        persistent-hint
                                        variant="outlined"
                                        :hint="'Min # of Hedge Funds Holding Stock in Current Quarter '"
                                      />
                                      <v-text-field
                                        v-model="editedMetric.threshold"
                                        style="max-width: 200px"
                                        density="compact"
                                        persistent-hint
                                        variant="outlined"
                                        :hint="
                                          (editedMetric.metric == 'rising_stars' ? 'Max' : 'Min') +
                                          ' Percentile Ranking (0 to 100) of Change in HF Ownership'
                                        "
                                      />
                                      <span class="text--disabled"
                                        >The lower the number the higher the stock's ranking</span
                                      >
                                    </v-col>
                                    <v-col
                                      v-if="
                                        editedMetric.metric &&
                                        (editedMetric.metric == 'exclude_top_holdings' ||
                                          editedMetric.metric == 'include_top_holdings')
                                      "
                                      cols="12"
                                      sm="12"
                                    >
                                      <v-text-field
                                        v-model="editedMetric.max"
                                        style="max-width: 400px"
                                        density="compact"
                                        persistent-hint
                                        variant="outlined"
                                        :hint="
                                          'Enter # of most widely held stocks to ' +
                                          (editedMetric.metric == 'exclude_top_holdings'
                                            ? 'exclude'
                                            : 'include')
                                        "
                                      />
                                    </v-col>
                                    <v-col
                                      v-if="
                                        editedMetric.metric &&
                                        editedMetric.metric == 'sector_buy_trade_percentage'
                                      "
                                    >
                                      Only buy stocks when the stock's buy/trade % is
                                      <v-select
                                        v-model="editedMetric.comparison"
                                        :items="comparison_options_not_between"
                                        label="Restrict"
                                        item-title="description"
                                        item-value="id"
                                        variant="outlined"
                                        density="compact"
                                        hide-details
                                      />
                                      the overall sector's buy/trade % by at least
                                      <v-text-field
                                        v-if="editedMetric.comparison == 1"
                                        v-model="editedMetric.min"
                                        density="compact"
                                        style="max-width: 100px"
                                        hide-details
                                        variant="outlined"
                                        label="%"
                                      />
                                      <v-text-field
                                        v-else-if="editedMetric.comparison == 2"
                                        v-model="editedMetric.max"
                                        density="compact"
                                        hide-details
                                        variant="outlined"
                                        label="%"
                                      />
                                    </v-col>
                                    <v-col
                                      v-if="
                                        editedMetric.metric &&
                                        editedMetric.metric == 'sector_buy_trade_percentage_hedge'
                                      "
                                    >
                                      Only buys stocks when the stock's hedge buy/trade % is
                                      <v-select
                                        v-model="editedMetric.comparison"
                                        :items="comparison_options_not_between"
                                        label="Restrict"
                                        item-title="description"
                                        item-value="id"
                                        variant="outlined"
                                        density="compact"
                                        hide-details
                                      />
                                      the overall sector's buy/trade % by at least
                                      <v-text-field
                                        v-if="editedMetric.comparison == 1"
                                        v-model="editedMetric.min"
                                        density="compact"
                                        style="max-width: 100px"
                                        hide-details
                                        variant="outlined"
                                        label="%"
                                      />
                                      <v-text-field
                                        v-else-if="editedMetric.comparison == 2"
                                        v-model="editedMetric.max"
                                        density="compact"
                                        hide-details
                                        variant="outlined"
                                        label="%"
                                      />
                                    </v-col>
                                    <v-col
                                      v-else-if="
                                        editedMetric.metric &&
                                        editedMetric.metric != 'exclude_top_holdings' &&
                                        editedMetric.metric != 'include_top_holdings' &&
                                        editedMetric.metric != 'exclude_concentrated' &&
                                        editedMetric.metric != 'include_concentrated' &&
                                        editedMetric.metric != 'sector_buy_trade_percentage' &&
                                        editedMetric.metric != 'rising_stars' &&
                                        editedMetric.metric != 'falling_stars' &&
                                        editedMetric.metric !=
                                          'sector_buy_trade_percentage_hedge' &&
                                        editedMetric.metric != 'exclude_overcrowded' &&
                                        editedMetric.metric != 'include_overcrowded'
                                      "
                                      cols="12"
                                      sm="12"
                                    >
                                      <v-row density="compact">
                                        <v-col cols="12" sm="12" md="4">
                                          <v-select
                                            v-model="editedMetric.comparison"
                                            :items="comparison_options"
                                            label="Restrict"
                                            item-title="description"
                                            item-value="id"
                                            variant="outlined"
                                            density="compact"
                                            hide-details
                                          />
                                        </v-col>
                                        <v-col cols="12" sm="12" md="4">
                                          <v-text-field
                                            v-if="
                                              editedMetric.comparison == 1 ||
                                              editedMetric.comparison == 3
                                            "
                                            v-model="editedMetric.min"
                                            density="compact"
                                            hide-details
                                            variant="outlined"
                                            label="Enter Min."
                                          />
                                          <v-text-field
                                            v-if="editedMetric.comparison == 2"
                                            v-model="editedMetric.max"
                                            density="compact"
                                            hide-details
                                            variant="outlined"
                                            label="Enter Max."
                                          />
                                        </v-col>
                                        <v-col cols="12" sm="12" md="4">
                                          <v-text-field
                                            v-if="editedMetric.comparison == 3"
                                            v-model="editedMetric.max"
                                            density="compact"
                                            hide-details
                                            variant="outlined"
                                            label="Enter Max."
                                          />
                                        </v-col>
                                      </v-row>
                                    </v-col>
                                    <v-col
                                      v-if="
                                        editedMetric.metric &&
                                        (editedMetric.metric == 'exclude_concentrated' ||
                                          editedMetric.metric == 'include_concentrated')
                                      "
                                      cols="12"
                                      sm="12"
                                    >
                                      <v-row density="compact">
                                        <v-col cols="12">
                                          <span v-if="editedMetric.metric == 'exclude_concentrated'"
                                            >Exclude</span
                                          ><span v-else>Include</span>
                                          the most highly concentrated stocks. This will find the
                                          average % of portfolio for a given stock using the top __
                                          funds sorted by highest % of portfolio.
                                        </v-col>
                                        <v-col cols="12" sm="12"
                                          ><v-radio-group
                                            v-model="editedMetric.filer_types"
                                            row
                                            hide-details
                                          >
                                            <v-radio
                                              label="All Funds"
                                              value="all"
                                              color="primary"
                                              hint=""
                                              persistent-hint />
                                            <v-radio
                                              label="Only Hedge Funds"
                                              value="hedge"
                                              color="primary"
                                              hint=""
                                              persistent-hint
                                          /></v-radio-group>
                                        </v-col>
                                        <v-col cols="12" sm="12" md="4">
                                          <v-text-field
                                            v-model="editedMetric.max"
                                            density="compact"
                                            hide-details
                                            variant="outlined"
                                            label="Max Stocks to Use"
                                          />
                                        </v-col>
                                        <v-col cols="12" sm="12">
                                          <v-text-field
                                            v-model="editedMetric.minimum_holdings"
                                            density="compact"
                                            hide-details
                                            variant="outlined"
                                            label="Min. # of holdings per fund (optional)"
                                          />
                                        </v-col>
                                        <v-col cols="12" sm="12">
                                          <v-text-field
                                            v-model="editedMetric.minimum_aum"
                                            density="compact"
                                            hide-details
                                            variant="outlined"
                                            label="Min. AUM of fund (optional)"
                                          />
                                        </v-col>
                                        <v-col cols="12" sm="12">
                                          <v-text-field
                                            v-model="editedMetric.number_of_funds"
                                            density="compact"
                                            hide-details
                                            variant="outlined"
                                            label="Max # of funds to look at. (optional)"
                                          />
                                        </v-col>
                                      </v-row>
                                    </v-col>

                                    <v-col
                                      v-if="
                                        editedMetric.metric &&
                                        (editedMetric.metric == 'exclude_overcrowded' ||
                                          editedMetric.metric == 'include_overcrowded')
                                      "
                                      cols="12"
                                      sm="12"
                                    >
                                      <v-row density="compact">
                                        <v-col cols="12">
                                          <span v-if="editedMetric.metric == 'exclude_overcrowded'"
                                            >Exclude the most overcrowded stocks. Find stocks whose
                                            ownership % is less than the threshold entered for
                                            either all filers or hedge fund filers only.</span
                                          >

                                          <span v-else
                                            >Include the most overcrowded stocks. Find stocks whose
                                            ownership % is over a certain threshold for either all
                                            filers or hedge fund filers only.</span
                                          >
                                        </v-col>
                                        <v-col cols="12" sm="12"
                                          ><v-radio-group
                                            v-model="editedMetric.filer_types"
                                            row
                                            hide-details
                                          >
                                            <v-radio
                                              label="All Funds"
                                              value="all"
                                              color="primary"
                                              hint=""
                                              persistent-hint />
                                            <v-radio
                                              label="Only Hedge Funds"
                                              value="hedge"
                                              color="primary"
                                              hint=""
                                              persistent-hint
                                          /></v-radio-group>
                                        </v-col>
                                        <v-col cols="12" sm="12" md="4">
                                          <v-text-field
                                            v-model="editedMetric.max"
                                            density="compact"
                                            hide-details
                                            variant="outlined"
                                            label="Max Stocks to Use"
                                          />
                                        </v-col>
                                        <v-col cols="12" sm="12">
                                          <v-text-field
                                            v-model="editedMetric.min"
                                            density="compact"
                                            hide-details
                                            variant="outlined"
                                            label="% ownership threshold"
                                          />
                                        </v-col>
                                      </v-row>
                                    </v-col>

                                    <v-col
                                      v-if="
                                        editedMetric.metric &&
                                        editedMetric.metric == 'significant_buys'
                                      "
                                      cols="12"
                                      sm="12"
                                    >
                                      <v-row density="compact">
                                        <v-col cols="12">
                                          <span
                                            >Only include stocks with significant impact buying
                                            during the quarter</span
                                          >
                                        </v-col>
                                        <v-col cols="12" sm="12"
                                          ><v-radio-group
                                            v-model="editedMetric.filer_types"
                                            row
                                            hide-details
                                          >
                                            <v-radio
                                              label="All Funds"
                                              value="all"
                                              color="primary"
                                              hint=""
                                              persistent-hint
                                            />
                                            <v-radio
                                              label="Only Hedge Funds"
                                              value="hedge"
                                              color="primary"
                                              hint=""
                                              persistent-hint
                                            />
                                            <v-radio
                                              label="Managers With Historical Winning % with Significant Buys"
                                              value="winners"
                                              color="primary"
                                              hint=""
                                              persistent-hint
                                            />
                                          </v-radio-group>
                                        </v-col>
                                        <v-col cols="12" sm="12" md="8">
                                          <v-text-field
                                            v-model="editedMetric.min_buyers"
                                            density="compact"
                                            hide-details
                                            variant="outlined"
                                            label="Minimum # of Significant Buyers"
                                          />
                                        </v-col>
                                        <v-col cols="12" sm="12" md="8">
                                          <v-text-field
                                            v-model="editedMetric.threshold"
                                            density="compact"
                                            hide-details
                                            variant="outlined"
                                            label="Threshold to be considered a signifiant buy (0 to 100)"
                                          />
                                        </v-col>
                                        <v-col cols="12" sm="12">
                                          <v-text-field
                                            v-if="editedMetric.filer_types == 'winners'"
                                            v-model="editedMetric.min"
                                            density="compact"
                                            hide-details
                                            variant="outlined"
                                            label="Minimum Prev. Winning Sig. Buys %"
                                          />
                                        </v-col>
                                        <v-col cols="12" sm="12">
                                          <v-text-field
                                            v-if="editedMetric.filer_types == 'winners'"
                                            v-model="editedMetric.min_previous_buys"
                                            density="compact"
                                            hide-details
                                            variant="outlined"
                                            label="Minimum Previous Buy Count"
                                          />
                                        </v-col>
                                      </v-row>
                                    </v-col>
                                  </v-row>
                                </v-container>
                              </v-card-text>

                              <v-card-actions>
                                <div class="flex-grow-1" />
                                <v-btn color="blue-darken-1" text @click="closeMetric">
                                  Cancel
                                </v-btn>
                                <v-btn color="blue-darken-1" text @click="saveMetric"> Save </v-btn>
                              </v-card-actions>
                            </v-card>
                          </v-dialog>
                        </template>
                        <template #item.metric_description="{ item }">
                          <div>
                            {{ LookupMetric(item.metric) }}
                            <div
                              v-if="
                                item.metric &&
                                (item.metric == 'exclude_concentrated' ||
                                  item.metric == 'include_concentrated')
                              "
                            >
                              <span v-if="item.metric == 'exclude_concentrated'">Exclude</span
                              ><span v-else>Include</span> the top {{ item.max }} most highly
                              concentrated stocks. The average % of portfolio for all stocks
                              <span v-if="item.filer_types == 'all'">
                                using
                                <span v-if="item.number_of_funds"
                                  >the top {{ item.number_of_funds }} by % of portfolio</span
                                ><span v-else>all</span> filers.</span
                              >
                              <span v-else>
                                using
                                <span v-if="item.number_of_funds"
                                  >the top {{ item.number_of_funds }} hedge funds by % of
                                  portfolio</span
                                ><span v-else>all hedge funds.</span></span
                              >
                              <span v-if="item.minimum_holdings"
                                >Only funds with at least {{ item.minimum_holdings }} holdings in
                                their portfolio will be used.</span
                              >
                              <span v-if="item.minimum_aum"
                                >Only funds with an AUM of at least {{ item.minimum_aum }} will be
                                used.</span
                              >
                            </div>
                            <div
                              v-if="
                                item.metric &&
                                (item.metric == 'rising_stars' || item.metric == 'falling_stars')
                              "
                            >
                              Only select stocks where the Percentile Ranking of the change in hedge
                              fund ownership quarter over quarter is
                              <span v-if="item.metric == 'rising_stars'"> within the top</span>
                              <span v-else>below the top</span> {{ item.threshold }}. Minimum Hedge
                              Funds Previous quarter is {{ item.min }}. Minimum Hedge Funds Current
                              Quarter is {{ item.min2 }}.
                            </div>
                            <div v-if="item.metric && item.metric == 'significant_buys'">
                              {{ item.threshold }}% significant buy %, minimum
                              {{ item.min_buyers }} buyers, using {{ item.filer_types }} funds.
                              <span v-if="item.filer_types == 'winners'"
                                >Must have {{ item.min }} minimum winning percentage with at least
                                {{ item.min_previous_buys }} previous buys (past 3 years)</span
                              >
                            </div>
                            <div
                              v-if="
                                item.metric &&
                                (item.metric == 'exclude_overcrowded' ||
                                  item.metric == 'include_overcrowded')
                              "
                            >
                              <span v-if="item.metric == 'exclude_overcrowded'"
                                >Only include the {{ item.max }} least</span
                              ><span v-else>Only Include the {{ item.max }} top</span>
                              overcrowded stocks.
                              <span v-if="item.metric == 'exclude_overcrowded'">The maximum </span
                              ><span v-else>The minimum </span> % ownership held by
                              <span v-if="item.filer_types == 'all'">all funds</span
                              ><span v-else>hedge funds only</span> is {{ item.min }}
                            </div>
                            <div v-else>
                              <div v-if="item.metric == 'exclude_top_holdings'">
                                Top {{ item.max }} most widely held stocks
                              </div>
                              <div v-else-if="item.metric == 'include_top_holdings'">
                                Top {{ item.max }} most widely held stocks
                              </div>
                              <div v-else-if="item.comparison == 1">
                                is greater than {{ item.min }}
                              </div>
                              <div v-else-if="item.comparison == 2">
                                is less than or equal to {{ item.max }}
                              </div>
                              <div v-else-if="item.comparison == 3">
                                is between {{ item.min }} and {{ item.max }}
                              </div>
                            </div>
                          </div>
                        </template>
                        <template #item.action="{ item }">
                          <v-icon small class="mr-2" @click="editMetric(item)">
                            {{ mdiPencil }}
                          </v-icon>
                          <v-icon small @click="deleteMetric(item)">
                            {{ mdiDelete }}
                          </v-icon>
                        </template>

                        <template #item.enabled="{ item }">
                          <v-switch v-model="item.enabled" color="primary" />
                        </template>
                        <template #no-data> No 13F indicators configured </template>
                      </v-data-table>
                    </v-col>
                  </v-row>
                </v-card-text>
                <v-card-actions>
                  <v-spacer />
                  <v-btn color="primary" variant="outlined" @click="closeGroup"> Cancel </v-btn>
                  <v-btn color="primary" variant="outlined" @click="saveGroup"> Save </v-btn>
                </v-card-actions>
              </v-card>
            </v-dialog>
          </template>
          <template #item.group_description="{ item }">
            <div>
              <span v-if="item.and_or == 1">All rules must match</span>
              <span v-else-if="item.and_or == 2">Any rule matches</span>
              <ul>
                <li v-for="rule in item.metric_rules" :key="rule.metric">
                  <span v-if="rule.enabled">Enabled: </span>
                  <span v-else>Not Enabled: </span>
                  {{ LookupMetric(rule.metric) }}
                  <div
                    v-if="
                      rule.metric &&
                      (rule.metric == 'exclude_concentrated' ||
                        rule.metric == 'include_concentrated')
                    "
                  >
                    <span v-if="rule.metric == 'exclude_concentrated'">Exclude</span
                    ><span v-else>Include</span> the top {{ rule.max }} highly concentrated stocks.
                    The average % of portfolio for all stocks
                    <span v-if="rule.filer_types == 'all'">
                      using
                      <span v-if="rule.number_of_funds"
                        >the top {{ rule.number_of_funds }} by % of portfolio</span
                      ><span v-else>all</span> filers.</span
                    >
                    <span v-else>
                      using
                      <span v-if="rule.number_of_funds"
                        >the top {{ rule.number_of_funds }} hedge funds by % of portfolio</span
                      ><span v-else>all hedge funds.</span></span
                    >
                    <span v-if="rule.minimum_holdings"
                      >Only funds with at least {{ rule.minimum_holdings }} holdings in their
                      portfolio will be used.</span
                    >
                    <span v-if="rule.minimum_aum"
                      >Only funds with an AUM of at least {{ rule.minimum_aum }} will be used.</span
                    >
                  </div>
                  <div v-if="rule.metric && rule.metric == 'significant_buys'">
                    {{ rule.threshold }}% significant buy %, minimum {{ rule.min_buyers }} buyers,
                    using {{ rule.filer_types }} funds.
                    <span v-if="rule.filer_types == 'winners'"
                      >Must have {{ rule.min }} minimum winning percentage with at least
                      {{ item.min_previous_buys }} previous buys (past 3 years)</span
                    >
                  </div>
                  <div
                    v-if="
                      rule.metric &&
                      (rule.metric == 'rising_stars' || rule.metric == 'falling_stars')
                    "
                  >
                    Only select stocks where the Percentile Ranking of the change in hedge fund
                    ownership quarter over quarter is
                    <span v-if="rule.metric == 'rising_stars'"> within the top</span>
                    <span v-else>below the top</span> {{ rule.threshold }}. Minimum Hedge Funds
                    Previous quarter is {{ rule.min }} Minimum Hedge Funds Current Quarter is
                    {{ rule.min2 }}.
                  </div>
                  <div
                    v-if="
                      rule.metric &&
                      (rule.metric == 'exclude_overcrowded' || rule.metric == 'include_overcrowded')
                    "
                  >
                    <span v-if="rule.metric == 'exclude_overcrowded'"
                      >Only include the {{ rule.max }} least</span
                    ><span v-else>Only Include the {{ rule.max }} top</span>
                    overcrowded stocks.
                    <span v-if="rule.metric == 'exclude_overcrowded'">The maximum </span
                    ><span v-else>The minimum </span> % ownership held by
                    <span v-if="rule.filer_types == 'all'">all funds</span
                    ><span v-else>hedge funds only</span> is {{ rule.min }}
                  </div>
                  <div v-else>
                    <div v-if="rule.metric == 'exclude_top_holdings'">
                      Top {{ rule.max }} most widely held stocks
                    </div>
                    <div v-else-if="rule.metric == 'include_top_holdings'">
                      Top {{ rule.max }} most widely held stocks
                    </div>
                    <div v-else-if="rule.comparison == 1">is greater than {{ rule.min }}</div>
                    <div v-else-if="rule.comparison == 2">
                      is less than or equal to {{ rule.max }}
                    </div>
                    <div v-else-if="rule.comparison == 3">
                      is between {{ rule.min }} and {{ rule.max }}
                    </div>
                  </div>
                </li>
              </ul>
            </div>
          </template>
          <template #item.action="{ item }">
            <v-icon small class="mr-2" @click="editGroup(item)">
              {{ mdiPencil }}
            </v-icon>
            <v-icon small @click="deleteGroup(item)">
              {{ mdiDelete }}
            </v-icon>
          </template>

          <template #item.enabled="{ item }">
            <v-switch v-model="item.enabled" color="primary" />
          </template>
          <template #no-data>
            <span>No Rule Groups configured</span>
          </template>
        </v-data-table>
      </v-col>
    </v-row>
  </div>
</template>

<script>
// Modules
import { useUserStore, useAppStore, useWwStore } from '@/store'
// Modules
import { mapWritableState } from 'pinia'
import cloneDeep from 'lodash/cloneDeep'
import { mdiDelete, mdiPen, mdiPencil } from '@mdi/js'
export default {
  data() {
    return {
      mdiDelete,
      mdiPen,
      mdiPencil,
      metricDialog: false,
      groupDialog: false,
      comparison_options: [
        { id: 1, description: 'Greater Than' },
        { id: 2, description: 'Less Than or equal to' },
        { id: 3, description: 'Between' }
      ],
      comparison_options_not_between: [
        { id: 1, description: 'Greater Than' },
        { id: 2, description: 'Less Than' }
      ],
      defaultRule: { enabled: true, and_or: 1, metric_rules: [] },
      defaultMetricRule: {
        metric: null,
        enabled: true,
        min: null,
        max: null,
        comparison: 1,
        filer_types: 'all',
        number_of_funds: 100,
        minimum_holdings: null,
        minimum_aum: null
      },
      metrics: [
        {
          id: 'exclude_top_holdings',
          name: 'Exclude most widely held stocks by 13F Filers',
          description: '',
          enabled: true
        },
        {
          id: 'include_top_holdings',
          name: 'Only include the most widely held stocks by 13F Filers',
          description: '',
          enabled: true
        },
        { id: 'funds_holding', name: '# of Funds Holding', description: '', enabled: true },
        {
          id: 'hedge_funds_holding',
          name: '# of Hedge Funds Holding',
          description: '',
          enabled: true
        },
        {
          id: 'change_funds_holding',
          name: '% Change in # of Funds Holding',
          description: '',
          enabled: true
        },
        {
          id: 'hedge_funds_change_holding',
          name: '% Change in # of Hedge Funds Holding',
          description: '',
          enabled: true
        },
        { id: 'put_call_ratio', name: 'PUT/CALL Ratio', description: '', enabled: true },
        {
          id: 'hedge_put_call_ratio',
          name: 'Hedge Fund PUT/CALL Ratio',
          description: '',
          enabled: true
        },
        { id: 'ranking', name: 'Avg 13F Ranking', description: '', enabled: true },
        { id: 'hedge_ranking', name: 'Avg 13F Hedge Fund Ranking', description: '', enabled: true },
        {
          id: 'pct_change_shares',
          name: '% Change Total Shares Held',
          description: '',
          enabled: true
        },
        {
          id: 'hedge_pct_change_shares',
          name: '% Change Hedge Fund Total Shares Held',
          description: '',
          enabled: true
        },
        {
          id: 'net_flow_mc',
          name: 'Net Flows as a % of Marketcap',
          description: '',
          enabled: true
        },
        {
          id: 'net_flow_mc_hedge',
          name: 'Net Hedge Fund Flows as a % of Marketcap',
          description: '',
          enabled: true
        },
        //  { id: 'exclude_concentrated', name: 'Exclude the most concentrated stocks', description: '', enabled: true },
        {
          id: 'include_concentrated',
          name: 'Only include the most concentrated stocks',
          description: '',
          enabled: true
        },
        {
          id: 'exclude_overcrowded',
          name: 'Only include the least overcrowded stocks',
          description: '',
          enabled: true
        },
        {
          id: 'include_overcrowded',
          name: 'Only include the most overcrowded stocks',
          description: '',
          enabled: true
        },
        {
          id: 'buy_sell_ratio',
          name: 'Buy / Sell Ratio (over 1 indicates more buying)',
          description: '',
          enabled: true
        },
        {
          id: 'buy_sell_ratio_hedge',
          name: 'Buy / Sell Ratio Hedge (over 1 indicates more buying)',
          description: '',
          enabled: true
        },
        {
          id: 'buy_trade_percentage',
          name: '(Buys / Total Trades) %',
          description: '',
          enabled: true
        },
        {
          id: 'buy_trade_percentage_hedge',
          name: '(Buys Hedge / Total Trades Hedge) %',
          description: '',
          enabled: true
        },
        {
          id: 'sector_buy_sell_ratio',
          name: 'Sector/Industry Buy/Sell Ratio',
          description: '',
          enabled: true
        },
        {
          id: 'sector_buy_sell_ratio_hedge',
          name: ' Sector/Industry Buy/Sell Ratio Hedge',
          description: '',
          enabled: true
        },
        {
          id: 'real_sector_buy_trade_percentage',
          name: 'Sector/Industry Buys over Trades %',
          description: '',
          enabled: true
        },
        {
          id: 'real_sector_buy_trade_percentage_hedge',
          name: ' Sector/Industry Buys over Trades % Hedge',
          description: '',
          enabled: true
        },
        {
          id: 'sector_buy_trade_percentage',
          name: 'Stock Buys/Total Trades vs Sector/Industry Buys/Total Trades',
          description: '',
          enabled: true
        },
        {
          id: 'sector_buy_trade_percentage_hedge',
          name: 'Stock Buys/Total Trades Hedge vs Sector/Industry Buys/Total Trades Hedge',
          description: '',
          enabled: true
        },
        {
          id: 'rising_stars',
          name: 'Rising Stars (increase in QoQ Hedge Fund Ownership)',
          description: '',
          enabled: true
        },
        { id: 'significant_buys', name: 'Significant Impact Buys', description: '', enabled: true }
      ],
      group_headers: [
        {
          title: 'Enabled',
          align: 'left',
          sortable: true,
          key: 'enabled'
        },
        {
          title: 'Description',
          align: 'left',
          sortable: false,
          key: 'group_description'
        },
        { title: 'Actions', key: 'action', sortable: false }
      ],
      metric_headers: [
        {
          title: 'Enabled',
          align: 'left',
          sortable: true,
          key: 'enabled'
        },
        {
          title: 'Description',
          align: 'left',
          sortable: false,
          key: 'metric_description'
        },
        { title: 'Actions', key: 'action', sortable: false }
      ],
      editedGroup: { enabled: true, and_or: 1, metric_rules: [] },
      editedIndex: -1,
      editedMetric: {
        metric: null,
        enabled: true,
        min: null,
        max: null,
        comparison: 'gt',
        filer_types: 'all',
        number_of_funds: 100,
        minimum_holdings: null,
        minimum_aum: null,
        min_previous_buys: 2
      },
      editedMetricIndex: -1
    }
  },
  computed: {
    groupTitle() {
      return this.editedIndex === -1 ? 'New Rule Group' : 'Edit Rule Group'
    },
    metricTitle() {
      return this.editedIndex === -1 ? 'New 13F Indicator Rule' : 'Edit Indicator Rule'
    },
    ...mapWritableState(useAppStore, ['whaleTraderCriteria']),
    criteria() {
      return this.whaleTraderCriteria.signals.f13_indicator_signal
    },
    appcriteria() {
      return this.whaleTraderCriteria
    },
    enabled() {
      return this.whaleTraderCriteria.signals.f13_indicator_signal.enabled
    }
    /*...mapFields({
      appcriteria: 'app.whaleTraderCriteria',
      criteria: 'app.whaleTraderCriteria.signals.f13_indicator_signal',
      enabled: 'app.whaleTraderCriteria.signals.f13_indicator_signal.enabled',
      signalView: 'app.signalView'
    })*/
  },
  methods: {
    LookupMetric(metric) {
      var desc = ''
      for (var i = 0; i < this.metrics.length; i++) {
        var m = this.metrics[i]
        if (m.id == metric) {
          desc = m.name
          break
        }
      }
      return desc
    },
    editGroup(item) {
      this.editedIndex = this.criteria.rules.indexOf(item)
      this.editedGroup = Object.assign({}, item)
      this.groupDialog = true
    },

    deleteGroup(item) {
      const index = this.criteria.rules.indexOf(item)
      confirm('Are you sure you want to delete this rule?') && this.criteria.rules.splice(index, 1)
    },

    closeGroup() {
      this.groupDialog = false
      this.editedGroup = cloneDeep(this.defaultRule) // Object.assign({}, this.defaultRule)
      this.editedIndex = -1
    },

    saveGroup() {
      if (this.editedIndex > -1) {
        Object.assign(this.criteria.rules[this.editedIndex], this.editedGroup)
      } else {
        if (!this.criteria.rules) {
          this.criteria.rules = []
        }
        this.criteria.rules.push(this.editedGroup)
      }
      this.closeGroup()
    },

    editMetric(item) {
      this.editedMetricIndex = this.editedGroup.metric_rules.indexOf(item)
      this.editedMetric = Object.assign({}, item)
      this.metricDialog = true
    },

    deleteMetric(item) {
      const index = this.editedGroup.metric_rules.indexOf(item)
      confirm('Are you sure you want to delete this rule?') &&
        this.editedGroup.metric_rules.splice(index, 1)
    },

    closeMetric() {
      this.metricDialog = false
      setTimeout(() => {
        this.editedMetric = Object.assign({}, this.defaultMetricRule)
        this.editedMetricIndex = -1
      }, 300)
    },

    saveMetric() {
      if (this.editedMetricIndex > -1) {
        Object.assign(this.editedGroup.metric_rules[this.editedMetricIndex], this.editedMetric)
      } else {
        if (!this.editedGroup.metric_rules) {
          this.editedGroup.metric_rules = []
        }
        this.editedGroup.metric_rules.push(this.editedMetric)
      }
      this.closeMetric()
    }
  }
}
</script>
